import { styled } from '@mui/material';

export const ScrollSliderContainer = styled('div')(({ theme }) => ({
  width: '100vw',
  position: 'fixed',
  bottom: 0,
  left: 0,
  boxShadow: '0 3px 6px 0 rgba(31, 27, 27, 0.16)',
  '.scroll-slider-inner': {
    gap: '14px',
    borderTop: '1px solid rgba(220, 221, 220, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '17px 34px',
    width: '100%',
    backgroundColor: theme.vars?.palette?.background?.default,
    color: theme.vars?.palette?.text?.primary,
    fontSize: '12px',
    fontWeight: 'bold',
  },
  transition: 'transform 0.6s',
  zIndex: 100,
  '&.scroll-on': {
    transform: 'translateY(0)',
  },
  '&.scroll-off': {
    transform: 'translateY(105%)',
  },
}));
